import { PlanInfo } from "../entities/PlanInfo";
import { CONTENT_MENU_ID } from "~/consts/contentsConfig";
import { CONTRACT_STATUS_CODE } from "~/consts/Plan";

export function getOwnerIds(planInfo: PlanInfo): string[] {
  return [planInfo.planOwner!.userId, ...planInfo.subOwnerIds];
}

export interface IPlanBillingType {
  name: string; // 表示名
  type: "contract_period" | "only_once"; // 契約タイプ (contract_period: サブスクリプション, only_once: 一度きり)
  contractPeriod?: number; // 契約期間 (contract_periodの場合のみ)
  availableDays?: number; // 有効日数 (only_onceの場合のみ)
}

export const PLAN_PRICE_BILLING_TYPE_LIST: IPlanBillingType[] = [
  // サブスク 1ヶ月、2ヶ月、3ヶ月、4ヶ月、5ヶ月、6ヶ月
  { name: "[サブスク]1ヶ月毎更新", type: "contract_period", contractPeriod: 1 },
  { name: "[サブスク]2ヶ月毎更新", type: "contract_period", contractPeriod: 2 },
  { name: "[サブスク]3ヶ月毎更新", type: "contract_period", contractPeriod: 3 },
  { name: "[サブスク]4ヶ月毎更新", type: "contract_period", contractPeriod: 4 },
  { name: "[サブスク]5ヶ月毎更新", type: "contract_period", contractPeriod: 5 },
  { name: "[サブスク]6ヶ月毎更新", type: "contract_period", contractPeriod: 6 },
  { name: "[サブスク]12ヶ月毎更新", type: "contract_period", contractPeriod: 12 },
  // 一括 1ヶ月、2ヶ月、3ヶ月、4ヶ月、5ヶ月、6ヶ月、無期限
  { name: "[一括]1ヶ月間利用", type: "only_once", contractPeriod: 1 },
  { name: "[一括]2ヶ月間利用", type: "only_once", contractPeriod: 2 },
  { name: "[一括]3ヶ月間利用", type: "only_once", contractPeriod: 3 },
  { name: "[一括]4ヶ月間利用", type: "only_once", contractPeriod: 4 },
  { name: "[一括]5ヶ月間利用", type: "only_once", contractPeriod: 5 },
  { name: "[一括]6ヶ月間利用", type: "only_once", contractPeriod: 6 },
  { name: "[一括]12ヶ月間利用", type: "only_once", contractPeriod: 12 },
  { name: "[一括]無期限", type: "only_once", contractPeriod: 0 },
];

export function getPlanBillingType(type: string, contractPeriod: number): IPlanBillingType | undefined {
  return PLAN_PRICE_BILLING_TYPE_LIST.find(billingType => {
    return billingType.type === type && billingType.contractPeriod === contractPeriod;
  });
}

// 契約済みか
export const isContractPlan = (plan?: PlanInfo) => {
  if (!plan) {
    return false;
  }
  switch (plan?.contractStatus.contractStatusCode) {
    case CONTRACT_STATUS_CODE.ACTIVE:
    case CONTRACT_STATUS_CODE.CANCELLATION:
      return true;
  }
  return false;
};

// Activeかどうか
export const isActivePlan = (plan?: PlanInfo) => {
  if (!plan) {
    return false;
  }
  return plan?.contractStatus.contractStatusCode === CONTRACT_STATUS_CODE.ACTIVE;
};

// 解約予定かどうか
export const isCancellationPlan = (plan?: PlanInfo) => {
  if (!plan) {
    return false;
  }
  return plan?.contractStatus.contractStatusCode === CONTRACT_STATUS_CODE.CANCELLATION;
};

// 仮解約中か
export const isProvisionalCancellationPlan = (plan?: PlanInfo) => {
  if (!plan) {
    return false;
  }
  return plan?.contractStatus.contractStatusCode === CONTRACT_STATUS_CODE.PROVISIONAL_CANCELLATION;
};

// 未契約か
export const isNoContractPlan = (plan?: PlanInfo) => {
  if (!plan) {
    return false;
  }
  return plan?.contractStatus.contractStatusCode === CONTRACT_STATUS_CODE.NO_CONTRACT;
};

// menuSortの最初の項目を取得
export const getFirstMenu = (plan?: PlanInfo) => {
  if (!plan) {
    return CONTENT_MENU_ID.LIVE;
  }
  const menuSort = plan.menuSort;
  const menuList = [
    { id: CONTENT_MENU_ID.LIVE, sort: menuSort.liveMovie },
    { id: CONTENT_MENU_ID.MOVIE, sort: menuSort.movie },
    { id: CONTENT_MENU_ID.DOCUMENT, sort: menuSort.document },
    { id: CONTENT_MENU_ID.ARTICLE, sort: menuSort.article },
  ];
  return menuList.sort((a, b) => a.sort - b.sort)[0].id;
};

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    getOwnerIds: (planInfo: PlanInfo) => string[];
    getPlanBillingType: (type: string, contractPeriod: number) => IPlanBillingType | undefined;
    isContractPlan: (plan?: PlanInfo) => boolean;
    isActivePlan: (plan?: PlanInfo) => boolean;
    isCancellationPlan: (plan?: PlanInfo) => boolean;
    isProvisionalCancellationPlan: (plan?: PlanInfo) => boolean;
    isNoContractPlan: (plan?: PlanInfo) => boolean;
  }
}
